import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Maladtopunecab() {



const cardData = {
  keyword: " Malad to Pune Cab ",

headingDescription: "Velocity Cab provides reliable and comfortable Malad to Pune cab services, ensuring a smooth and hassle-free journey for business trips, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Malad to Pune convenient and stress-free. The journey covers approximately 150–160 km via the Mumbai–Pune Expressway, typically taking 3–4 hours depending on traffic conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Malad to Pune cab travel.",

topPlaces: [
  {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered spiritual landmarks dedicated to Lord Ganesha. Devotees and travelers can experience divine blessings, beautifully decorated idols, and a vibrant atmosphere, especially during major festivals like Ganesh Chaturthi."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification in Pune that once served as the seat of the Peshwas of the Maratha Empire. Visitors can explore its grand gateways, ruins, and enjoy the evening light and sound show that narrates Pune’s royal history."
  },
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden is a serene Japanese-style garden featuring lush greenery, water streams, and beautifully designed walking paths. It is an ideal place for relaxation, photography, and peaceful nature walks."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a historically significant monument linked to India’s freedom movement. It features elegant architecture, spacious gardens, and a museum dedicated to Mahatma Gandhi and important historical events."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a popular heritage site in Pune offering panoramic city views from its hilltop temples. Visitors can climb the steps to explore ancient shrines and enjoy a peaceful, scenic environment."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a well-known garden in Pune featuring lush green spaces and the famous Siddhivinayak Temple. It is a favorite spot for families, walkers, and visitors seeking relaxation in the city."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a riverside park offering greenery, walking tracks, and boating facilities. It is a peaceful location for evening strolls and leisure activities in Pune."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases a rich collection of Indian artifacts, including sculptures, musical instruments, and cultural items that reflect India’s heritage and traditions."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a popular shopping and entertainment hub featuring international brands, restaurants, cinemas, and entertainment zones, making it ideal for leisure and shopping experiences."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It is known for its spiritual ambiance and historical significance in Pune."
  }
],



services: [
{
name: "Malad to Pune Cab",
description: "Malad to Pune cab service offers safe, comfortable, and reliable intercity travel for passengers looking for hassle-free transportation. This service is ideal for personal trips, corporate travel, and family journeys. Customers can choose from sedan, SUV, and premium vehicles based on their needs. Timely pickup and drop ensure a smooth journey experience. Transparent pricing with no hidden charges helps customers plan their budget easily. Flexible booking options make travel convenient. It is one of the most preferred cab services for Malad to Pune travel."
},
{
name: "Malad to Pune Cab Service",
description: "Malad to Pune cab service provides dependable transportation with well-maintained vehicles and experienced drivers. This service ensures comfort and safety for long-distance travel. Customers can choose from multiple vehicle options like sedan, SUV, and Innova. Transparent billing ensures no hidden charges. Flexible pickup and drop locations add convenience. Suitable for both one way and round trip travel. It ensures a smooth and stress-free journey."
},
{
name: "Malad to Pune Taxi",
description: "Malad to Pune taxi service offers affordable and convenient travel options for passengers seeking reliable rides. Vehicles are clean and well-maintained to ensure comfort during long journeys. Professional drivers ensure safe and timely service. Ideal for airport transfers, business travel, and personal trips. Transparent pricing ensures clarity in fares. Easy booking options make it convenient. It is a trusted taxi option for Malad to Pune routes."
},
{
name: "Malad to Pune Taxi Service",
description: "Malad to Pune taxi service provides economical and reliable travel solutions for all types of passengers. This service includes a variety of vehicle options such as sedan, SUV, and premium cars. Professional drivers ensure safe highway driving and timely pickups. Transparent pricing ensures no hidden costs. Flexible booking options enhance convenience. Suitable for both one way and round trip travel. It ensures a comfortable travel experience."
},
{
name: "Malad to Pune One Way Cab",
description: "Malad to Pune one way cab service is ideal for travelers who want cost-effective travel without return charges. This service reduces travel costs compared to round trip bookings. Customers can choose from multiple vehicle options based on comfort and budget. Professional drivers ensure safe and timely journeys. Transparent pricing ensures no hidden charges. Easy booking with instant confirmation adds convenience. It is the best option for one way travel."
},
{
name: "Malad to Pune One Way Taxi",
description: "Malad to Pune one way taxi service provides affordable single-side travel with flexible vehicle options. This service is perfect for passengers who do not require a return journey. Vehicles are well-maintained and comfortable for long-distance travel. Professional drivers ensure safe and smooth rides. Transparent pricing ensures no hidden fees. Flexible booking options make it convenient. It is a great choice for budget-friendly one way travel."
},
{
name: "Malad to Pune Cab Booking",
description: "Malad to Pune cab booking offers a quick and easy way to reserve your cab with instant confirmation. Customers can book online or via phone based on their preference. Multiple vehicle options are available to suit different travel needs. Professional drivers ensure timely pickups and safe journeys. Transparent pricing ensures clarity in billing. Flexible scheduling options enhance convenience. It ensures a hassle-free booking experience."
},
{
name: "Malad to Pune Taxi Booking Online",
description: "Malad to Pune taxi booking online provides a convenient way to book your cab from anywhere. Customers can compare vehicle options and fares easily before booking. Instant confirmation ensures quick travel planning. Professional drivers ensure safe and timely service. Transparent pricing avoids hidden charges. Flexible booking options enhance convenience. It is the best way to book your cab online."
},
{
name: "Cab from Malad to Pune",
description: "Cab from Malad to Pune offers comfortable and reliable transportation for intercity travel. This service is suitable for family trips, business travel, and personal journeys. Vehicles are well-maintained and equipped for long-distance travel. Professional drivers ensure smooth and safe rides. Flexible booking options make travel planning easy. Transparent pricing ensures no hidden charges. It is a convenient and trusted travel option."
},
{
name: "Malad to Pune Car Rental",
description: "Malad to Pune car rental service provides flexible and private travel options for customers who prefer comfort and convenience. Customers can choose from a wide range of vehicles including sedan, SUV, and premium cars. Well-maintained vehicles ensure a smooth ride. Professional drivers ensure safety and reliability. Transparent pricing ensures clear billing. Flexible rental plans suit different travel needs. It is ideal for both short and long trips."
},
{
name: "Malad to Pune Cab Fare",
description: "Malad to Pune cab fare is designed to be affordable and transparent for customers planning their travel. Pricing depends on vehicle type, trip type, and distance covered. Customers receive clear fare details before booking. No hidden charges ensure trust and reliability. Competitive pricing makes it budget-friendly. Flexible options allow customers to choose according to their needs. It helps in easy travel planning."
},
{
name: "Malad to Pune Taxi Charges",
description: "Malad to Pune taxi charges are calculated based on distance, vehicle type, and trip requirements. Customers receive upfront pricing with complete transparency. No hidden charges ensure a reliable booking experience. Affordable pricing options suit different budgets. Flexible travel options allow customers to choose one way or round trip. Professional drivers ensure safe journeys. It is ideal for cost-effective travel."
},
{
name: "Cheap Cab Malad to Pune",
description: "Cheap cab Malad to Pune offers budget-friendly travel options for passengers looking for economical rides. This service ensures comfortable travel at affordable rates. Vehicles are clean and well-maintained for safe journeys. Professional drivers ensure smooth travel experience. Transparent pricing ensures no hidden costs. Flexible booking options add convenience. It is perfect for budget-conscious travelers."
},
{
name: "Best Cab Service Malad to Pune",
description: "Best cab service Malad to Pune provides high-quality transportation with a focus on comfort, safety, and reliability. This service is preferred for its professional drivers and well-maintained vehicles. Transparent pricing ensures fair fares. Flexible booking options enhance convenience. Suitable for all travel needs including business and family trips. It ensures a premium and dependable travel experience."
},
{
name: "Malad to Pune Outstation Cab",
description: "Malad to Pune outstation cab service offers reliable transportation for long-distance travel with comfort and safety. This service is ideal for weekend trips, family travel, and corporate journeys. Vehicles are maintained for highway driving ensuring smooth rides. Professional drivers ensure safe and timely travel. Flexible options include one way and round trips. Transparent pricing ensures clear billing. It is a trusted option for outstation travel."
},
{
name: "Malad to Pune AC Taxi Service",
description: "Malad to Pune AC taxi service provides comfortable and air-conditioned travel for passengers seeking a premium experience. Vehicles are clean, well-maintained, and equipped with AC for long-distance comfort. Professional drivers ensure safe and smooth rides. Transparent pricing ensures no hidden charges. Flexible booking options make it convenient. It is ideal for comfortable travel."
},
{
name: "Malad to Pune Innova Cab",
description: "Malad to Pune Innova cab service offers spacious and comfortable travel for families and groups. This service is ideal for long-distance journeys with extra seating and luggage space. Vehicles are well-maintained and suitable for highway travel. Professional drivers ensure safe and smooth rides. Transparent pricing ensures clarity in fares. Flexible booking options make it convenient. It is a preferred choice for group travel."
},
{
name: "Malad to Pune Ertiga Cab",
description: "Malad to Pune Ertiga cab service is perfect for small groups and family travel with comfortable seating and good mileage. Vehicles are well-maintained and ideal for long-distance travel. Professional drivers ensure safe and timely service. Transparent pricing ensures no hidden charges. Flexible booking options add convenience. It is a popular choice for group travel."
},
{
name: "Malad to Pune SUV Taxi",
description: "Malad to Pune SUV taxi service offers powerful and comfortable vehicles suitable for long-distance travel. This service is ideal for family trips, corporate travel, and group journeys. Vehicles provide ample space and smooth highway performance. Professional drivers ensure safe and timely service. Transparent pricing ensures no hidden costs. Flexible booking options enhance convenience. It is a great option for SUV travel."
},
{
name: "Malad to Pune Cab Price",
description: "Malad to Pune cab price is structured to offer affordable and transparent fares for all types of travelers. Pricing varies based on vehicle type, trip type, and travel requirements. Customers receive clear fare details before booking. No hidden charges ensure trust and reliability. Competitive pricing makes it budget-friendly. Flexible options allow customers to choose according to their needs. It helps in easy travel planning."
}
],

tableData: [
["Malad to Pune Cab","Malad to Pune Taxi Service"],
["Malad to Pune One Way Cab","Malad to Pune Cab Booking"],
["Cheap Cab Malad to Pune","Malad to Pune Outstation Cab"],
["Malad to Pune Innova Cab","Malad to Pune SUV Taxi"],
["Malad to Pune Cab Price","Malad to Pune Ertiga Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Intercity Travel",
    WhyChoosedescription: "Velocity Cabs offers reliable Malad to Pune cab service for a smooth and comfortable journey via the Mumbai Pune Expressway, ideal for business trips, family travel, and weekend getaways."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Malad to Pune routes, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Malad to Pune cab bookings. Customers receive full fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Malad to Pune cab service operates 24/7. Whether you need early morning pickup or late-night travel, we ensure reliable cab availability anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, and same-day return trips between Malad and Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Malad to Pune cab bookings due to punctual drivers, clean vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Malad to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Malad to Pune for one-way and round-trip travel." },
  { question: "How far is Pune from Malad?", answer: "The distance between Malad and Pune is approximately 150 to 170 km and travel time is around 3.5 to 4.5 hours depending on traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Malad to Pune cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services from Malad to Pune." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Malad to Pune cabs online or through phone booking." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from homes, societies, and offices across Malad." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and peak travel hours." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karan Mehta",
    feedback:
      "The Malad to Pune cab journey was very comfortable and well-planned. The cab arrived on time, the ride was smooth, and the overall travel experience felt stress-free.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback:
      "From Malad to Pune, the travel experience was really good. The vehicle was clean, the drive was steady, and everything was handled in a professional and reliable way.",
    rating: 5
  }
];




















const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const maladPuneCabJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Malad to Pune Cab | Velocity Cabs",
  "description": "Book a private cab from Malad to Pune for comfortable outstation travel. AC, Sedan, Innova, Ertiga, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Malad, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Malad to Pune Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Malad to Pune",
        "description": "Private cab from Malad to Pune for one-way travel with AC, SUV, Sedan, Innova, or Ertiga options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Malad to Pune Cab",
        "description": "Comfortable round-trip cab service from Malad to Pune with private AC, SUV, Sedan, Innova, or Ertiga options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};



  return (
    <div>
     <Helmet>
  <title>Malad to Pune Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Malad to Pune for comfortable outstation travel. AC, Sedan, Innova, Ertiga, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(maladPuneCabJSON)}
  </script>
</Helmet>
 


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/116.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Maladtopunecab;